import * as React from "react"

function SvgLogo(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm0-3c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21z"
        fill="#fff"
      />
      <path
        d="M23.088 35.44v6.115a17.474 17.474 0 01-8.287-2.618V37.28a9.076 9.076 0 00-.597-3.546l-4.707-7.638a2.203 2.203 0 01-.348-1.243 1.657 1.657 0 01.265-.944C21.845 7.208 22.276 6.462 22.276 6.462c1.658 2.22.299 4.142-.58 5.766a47.008 47.008 0 01-1.21 2.137c-.829 1.359-1.84 2.9-2.801 4.44a6.112 6.112 0 00-1.11 3.646 7.57 7.57 0 001.475 4.291 19.738 19.738 0 003.861 3.844c.546.456.925 1.08 1.078 1.773.126 1.022.17 2.053.133 3.082"
        fill="#fff"
      />
      <path
        d="M18.05 22.368a5.946 5.946 0 013.627-5.542 5.953 5.953 0 018.154 4.29A5.947 5.947 0 0124 28.25a5.921 5.921 0 01-5.487-3.62 5.912 5.912 0 01-.463-2.262z"
        fill="#fff"
      />
      <path
        d="M38.503 26.096L33.812 33.7a9.096 9.096 0 00-.58 3.546v1.657a17.407 17.407 0 01-8.287 2.617v-6.08c-.038-1.03.006-2.06.132-3.082a3.314 3.314 0 011.094-1.773 19.66 19.66 0 003.845-3.844 7.455 7.455 0 001.476-4.291 6.113 6.113 0 00-1.177-3.695c-.962-1.541-1.973-3.082-2.818-4.44a47.008 47.008 0 01-1.21-2.138c-.895-1.657-2.22-3.546-.597-5.766 0 0 .448.746 12.879 17.447.187.28.286.608.282.945.006.43-.121.853-.365 1.21"
        fill="#fff"
      />
    </svg>
  )
}

export default SvgLogo

